<ng-container [formGroup]="group">
  <div class="field__container">
    @if (!hideIconSpace) {
      <mat-icon [ngClass]="{ focus: input.focused }">{{ icon }}</mat-icon>
    }
    <mat-form-field color="accent">
      @let isLoading = isLoadingEmployee$ | async;
      <mat-label>{{label}}</mat-label>
      @if (!control.disabled && !isLoading) {
        <mat-icon matSuffix class="suffix-icon">search</mat-icon>
      }
      @if (isLoading) {
        <mat-spinner matSuffix class="suffix-icon" [diameter]="21" color="accent"></mat-spinner>
      }
      <!-- readonly, not disabled, while the picked case loads: a disabled field drops focus -->
      <input
        matInput
        [matAutocomplete]="auto"
        [formControl]="control"
        [readonly]="isLoading"
        #input="matInput"
        autocomplete="off"/>
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn.bind(this)">
          @for(option of filteredOptions | async; track option) {
            <mat-option [value]="option">
              <div class="flex">
                <img [src]="option.employee.image || 'assets/images/missing_avatar.svg'" alt="" class="profile-image"/>
                {{ option.employee.description }}
              </div>
              <div class="leave-option-info">
                @if (option.employee.companyName) {
                  <span class="caption option-extras">
                    <span class="bullet-spacing">&bull;</span>
                    {{option.employee.companyName}}
                  </span>
                }
                @if (option.employee.workEmail) {
                  <span class="caption option-extras">
                    <span class="bullet-spacing">&bull;</span>
                    {{option.employee.workEmail}}
                  </span>
                }
                @if (option.employee.personalEmail) {
                  <span class="caption option-extras">
                    <span class="bullet-spacing">&bull;</span>
                    {{option.employee.personalEmail}}
                  </span>
                }
                <span class="caption option-extras">
                  <span class="bullet-spacing">&bull;</span>
                  {{(sysText.case | capitalizefirst) + '# ' + option.caseId}}
                </span>
                @if (option.showBank1Hours ||
                  option.showBank2Hours ||
                  option.showBank3Hours ||
                  option.showBank4Hours ||
                  option.showBank5Hours) {
                  <span
                    class="caption option-extras">
                    <span class="bullet-spacing">&bull;</span>
                    {{option | caseOptionFormatBanks : sysText.availableBankHours}}
                  </span>
                }
                <span class="caption option-extras">
                  <span class="bullet-spacing">&bull;</span>
                  {{(sysText.startDate | capitalizefirst) + ': '
                  + ((option.startDate | date) ?? '--')}}
                </span>
                <span class="caption option-extras">
                  <span class="bullet-spacing">&bull;</span>
                  {{(sysText.endDate | capitalizefirst) + ': '
                  + ((option.endDate | date) ?? '--')}}
                </span>
              </div>
            </mat-option>
          }
        </mat-autocomplete>
        <!-- mat hint for spacing -->
        <mat-hint></mat-hint>
        @if (control.errors?.msError) {
          <mat-error>{{ control.errors?.msError }}</mat-error>
        }
        @if (control.errors?.required) {
          <mat-error>{{ sysText.required | capitalizefirst }}</mat-error>
        }
      </mat-form-field>
    </div>
  </ng-container>